var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article-layout',[_c('h1',[_vm._v("Fout")]),_c('router-link',{attrs:{"to":"/puppy"}},[_vm._v("Terug")]),_c('h2',[_vm._v("Er ging iets mis bij het verzenden van uw reactie")]),_c('p')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }